export default "__VITE_ASSET__760c78c2__"